import { Box, Stack } from '@mui/material';
import Loader from '@components/common/loader/Loader';
import ViewDocuments from '@components/componentDocuments/list';
import { useState } from 'react';

export default function Documents(): JSX.Element {
  const [loader, setLoader] = useState(false);

  return (
    <>
      <Loader isActive={loader} />
      <Stack spacing={{ xs: 1, sm: 1, md: 1, xl: 1 }} direction="row">
        <Box sx={{ width: '100%' }}>
          <ViewDocuments setLoader={setLoader} />
        </Box>
      </Stack>
    </>
  );
}
